// src/components/Footer.js
import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap'; // <-- ENSURE 'Button' IS HERE
import { FaFacebookF, FaTwitter, FaPinterestP, FaInstagram, FaEnvelope, FaPhoneAlt, FaMapMarkerAlt } from 'react-icons/fa';
import { NavLink, useLocation } from 'react-router-dom';
import { Fade } from 'react-awesome-reveal';

const Footer = () => {
  const { pathname } = useLocation();

  const handleNavClick = (to) => {
    if (pathname === to) {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-dark text-white-50 pt-5 pb-3">
      <Container> 
        <Fade triggerOnce>
          <div className="py-5 px-4 bg-light-amiso mb-5 rounded-3">
            <Row className="align-items-center justify-content-between">
              <Col lg={6} className="mb-4 mb-lg-0">
                <h4 className="text-white fw-bold mb-2">Ready to grow your business online?</h4>
                <p className="text-muted mb-0">
                We create powerful websites, apps, and SEO strategies that deliver real results.
                </p>
              </Col>
              <Col lg={5}> 
                <div className="d-flex justify-content-center">
                  <Button as={NavLink} to="/contact-us" variant="primary" size="lg" className="px-4 py-3">
                    Contact Us
                  </Button>
                </div>
              </Col>
            </Row>
          </div>
        </Fade>

        <Row className="justify-content-between pb-4">
          <Col lg={4} md={6} className="text-center text-md-start mb-5 mb-lg-0">
            <Fade triggerOnce direction="up" delay={100}>
              <h5 className="fw-bold mb-4 text-white">Overview</h5>
              <p className="text-white-50 small pe-lg-4">
               Webbloom builds modern websites, apps, and SEO solutions for growing businesses. We focus on performance, design, and results that matter.
              </p>
              <div className="d-flex justify-content-center justify-content-md-start mt-4">
                <a href="https://www.facebook.com/share/1CV2WaVUdG/" className="text-white-50 me-3"><FaFacebookF size={18} /></a> 
                <a href="https://www.instagram.com/webbloomindia?igsh=Z25wMTc3bG1zZnlq" className="text-white-50"><FaInstagram size={18} /></a>
              </div>
            </Fade>
          </Col>

          <Col lg={2} md={6} className="text-center text-md-start mb-5 mb-lg-0">
            <Fade triggerOnce direction="up" delay={200}>
              <h5 className="fw-bold mb-4 text-white">Quick Links</h5>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <NavLink to="/" className="text-white-50 footer-link" end onClick={() => handleNavClick('/') }>
                    Home
                  </NavLink>
                </li>
                <li className="mb-2">
                  <NavLink to="/about-us" className="text-white-50 footer-link" onClick={() => handleNavClick('/about-us')}>
                    About Us
                  </NavLink>
                </li>
                <li className="mb-2">
                  <NavLink to="/services" className="text-white-50 footer-link" onClick={() => handleNavClick('/services')}>
                    Services
                  </NavLink>
                </li>
                <li className="mb-2">
                  <NavLink to="/contact-us" className="text-white-50 footer-link" onClick={() => handleNavClick('/contact-us')}>
                    Contact Us
                  </NavLink>
                </li>
              </ul>
            </Fade>
          </Col>

          <Col lg={3} md={6} className="text-center text-md-start mb-5 mb-lg-0">
            <Fade triggerOnce direction="up" delay={300}>
              <h5 className="fw-bold mb-4 text-white">Portfolio</h5>
              {/* Placeholder for small portfolio grid - ideally a component */}
              <Row className="g-2">
                 
                  <Col xs={6}>
                    <img src={`/assets/portfolio/1.jpg`} alt={`Webblomm Portfolio`} className="img-fluid rounded-3" />
                  </Col>
                <Col xs={6}>
                <img src={`/assets/portfolio/2.jpg`} alt={`Webblomm Portfolio`} className="img-fluid rounded-3" />
                </Col>
                <Col xs={6}>
                 <img src={`/assets/portfolio/3.jpg`} alt={`Webblomm Portfolio`} className="img-fluid rounded-3" />
                </Col>
                  <Col xs={6}>
                     <img src={`/assets/portfolio/4.jpg`} alt={`Webblomm Portfolio`} className="img-fluid rounded-3" />
                    </Col>
              </Row>
            </Fade>
          </Col>

          <Col lg={3} md={6} className="text-center text-md-start">
            <Fade triggerOnce direction="up" delay={400}>
              <h5 className="fw-bold mb-4 text-white">Contact Us</h5>
              <p className="text-white-50 mb-2"><FaMapMarkerAlt className="me-1" /> Andheri East <br />Mumbai, Maharashtra</p>
              <p className="text-white-50 mb-2"><FaEnvelope className="me-1" /> vishal@webbloom.in</p>
              <p className="text-white-50 mb-0"><FaPhoneAlt className="me-1" /> +91 6388414242</p>
            </Fade>
          </Col>
        </Row>
        
        <hr className="my-3 border-secondary opacity-25" /> 
          <p className="text-center mb-0 text-white-50 small">
              Webbloom &copy; {new Date().getFullYear()}. All Right Reserved.
          </p> 
      </Container>
    </footer>
  );
}

export default Footer;